import BusinessOwnership from '@/views/Admin/BusinessOwnership/BusinessOwnership.vue';
import { Route } from '../route.model';

const adminBusinessOwnership = new Route(
  '/admin/business-ownership',
  'business_ownership',
  BusinessOwnership,
  {
    isResponsive: true,
    requiresAuth: true,
    superRoot: true,
    navbar: {
      name: 'Businesses Ownership', // TODO apply i18n
      icon: 'coins'
    },
    zendesk: {
      disabled: true
    }
  }
);

export { adminBusinessOwnership };
export default adminBusinessOwnership;
